"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdpPaginationNext = function AdpPaginationNext(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M512 4.416c-281.6 0-512 230.4-512 512s230.4 512 512 512 512-230.4 512-512-230.4-512-512-512zm194.56 532.48l-276.48 276.48c-5.12 5.12-10.24 5.12-15.36 5.12s-10.24 0-15.36-5.12l-30.72-30.72c-5.12-5.12-5.12-10.24-5.12-15.36s0-10.24 5.12-15.36l230.4-230.4-225.28-235.52c-5.12-5.12-5.12-10.24-5.12-15.36s0-10.24 5.12-15.36l30.72-30.72h10.24c5.12 0 10.24 0 15.36 5.12l276.48 276.48c5.12 5.12 5.12 10.24 5.12 15.36s0 10.24-5.12 15.36z"
  })));
};

AdpPaginationNext.defaultProps = {
  viewBox: '0 0 1024 1043.776',
  height: '1em',
  width: '0.9811em'
};
AdpPaginationNext.displayName = 'AdpPaginationNext';
var _default = AdpPaginationNext;
exports.default = _default;